"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TextWithSeparatorOptions = exports.Logo = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Stack = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _jsxRuntime = require("react/jsx-runtime");
var _span, _span2;
const navbarLogoAltText = (0, _reactIntl.defineMessage)({
  id: "navbar.logo.alt_text"
});
const imagesBaseUrl = "https://images.kiwi.com";
let TextWithSeparatorOptions = exports.TextWithSeparatorOptions = /*#__PURE__*/function (TextWithSeparatorOptions) {
  TextWithSeparatorOptions["POWERED_BY_KIWI"] = "poweredByKiwi";
  return TextWithSeparatorOptions;
}({});
const LogoComponent = _ref => {
  let {
    id,
    redirectUrl,
    url,
    title,
    onClick
  } = _ref;
  const intl = (0, _reactIntl.useIntl)();
  if (id === "kiwicom") {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("a", {
      className: "relative flex outline-none group",
      "data-test": "Logo",
      href: url || redirectUrl,
      onClick: onClick,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        className: "hidden mm:block",
        title: intl.formatMessage(navbarLogoAltText, {
          brandName: title
        }),
        alt: intl.formatMessage(navbarLogoAltText, {
          brandName: title
        }),
        src: `${imagesBaseUrl}/common/kiwicom-logo.svg`,
        width: 80,
        height: 50
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        className: "block mm:hidden",
        title: intl.formatMessage(navbarLogoAltText, {
          brandName: title
        }),
        alt: intl.formatMessage(navbarLogoAltText, {
          brandName: title
        }),
        src: `${imagesBaseUrl}/common/kiwicom-logo-mobile-no-whitespace.svg`,
        width: 48,
        height: 40
      }), _span || (_span = /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "invisible group-focus:visible absolute inset-y-[-3px] inset-x-0 rounded-150 border-2 border-solid border-product-normal mm:inset-x-[-5px]"
      }))]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("a", {
    className: "flex",
    "data-test": "Logo",
    href: url || redirectUrl,
    onClick: onClick,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      className: "hidden lm:block lm:max-h-[35px] lm:max-w-[140px] lm:self-center",
      title: intl.formatMessage(navbarLogoAltText, {
        brandName: title
      }),
      alt: intl.formatMessage(navbarLogoAltText, {
        brandName: title
      }),
      srcSet: `${imagesBaseUrl}/whitelabels/0x80/${id}.png?v=1 2x`,
      src: `${imagesBaseUrl}/whitelabels/0x40/${id}.png?v=1`
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      className: "max-h-1000 max-w-1000 self-center lm:hidden",
      title: intl.formatMessage(navbarLogoAltText, {
        brandName: title
      }),
      alt: intl.formatMessage(navbarLogoAltText, {
        brandName: title
      }),
      srcSet: `${imagesBaseUrl}/whitelabels/0x80/${id}-mobile.png?v=1 2x`,
      src: `${imagesBaseUrl}/whitelabels/0x40/${id}-mobile.png?v=1`
    })]
  });
};
const LogoText = _ref2 => {
  let {
    textWithSeparator
  } = _ref2;
  switch (textWithSeparator) {
    case TextWithSeparatorOptions.POWERED_BY_KIWI:
      return _span2 || (_span2 = /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: "relative text-ink-dark text-[10px] font-base font-normal leading-[initial] ps-200 lm:text-small lm:font-medium lm:ps-300",
        children: ["Powered by", /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), "Kiwi.com", /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "absolute top-0 bottom-0 ltr:left-0 rtl:right-0 w-px h-600 m-auto bg-cloud-dark"
        })]
      }));
    default:
      return null;
  }
};
const Logo = _ref3 => {
  let {
    id,
    redirectUrl,
    title,
    url,
    textWithSeparator,
    onClick
  } = _ref3;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
    inline: true,
    direction: "row",
    align: "center",
    grow: false,
    spacing: "200",
    largeMobile: {
      spacing: "300"
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(LogoComponent, {
      title: title,
      id: id,
      url: url,
      redirectUrl: redirectUrl,
      onClick: onClick
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(LogoText, {
      textWithSeparator: textWithSeparator
    })]
  });
};
exports.Logo = Logo;
var _default = exports.default = Logo;